import { render, staticRenderFns } from "./MailReminderContent.vue?vue&type=template&id=159acccc"
import script from "./MailReminderContent.vue?vue&type=script&lang=js"
export * from "./MailReminderContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports